export const YET_TO_BE_DECIDED_UNIVERSITY_VALUE = 'Yet to Decide';

export const YET_TO_BE_DECIDED_UNIVERSITY_LABEL = 'Yet to Decide';

/**
 * `NiatApplicationMachine` context `seatReservationFlow` when the selected
 * institute has no online enrollment fee products (offline / “You’re all set” path).
 */
export const NON_ER_FLOW = 'NON_ER_FLOW' as const;

export const isYetToBeDecidedUniversityValue = (value: unknown): boolean =>
  String(value ?? '').trim() === YET_TO_BE_DECIDED_UNIVERSITY_VALUE;

/** NIAT program id for institute / course catalog APIs */
export const TAKE_ADMISSION_COLLEGE_OPTIONS = [
  'Anantapur - B.Tech - BESTIU',
  'Kanyakumari - B.Tech - Joy University',
  "Bangalore - B.Tech - St. Peter's Institute of Higher Education and Research",
  'Pune - B.Tech - Ajeenkya DY Patil',
  'Pune - B.Tech - Alard University',
  'Rajampet - B.Tech - Annamacharya',
  'Jaipur - B.Tech - VGU',
  'Bangalore - B.Tech - S-VYASA',
  'Chennai - B.Tech - AMET',
  'Kolhapur - B.Tech - Sanjay Ghodawat University',
  'Hyderabad - B.Tech - CDU',
  'Hyderabad - Degree - BITS',
  "Hyderabad - B.Tech - St. Mary's Rehabilitation University",
  'Mangalore - B.Tech - Yenepoya',
  'Bangalore - B.Tech - Yenepoya',
  'Hyderabad - B.Tech - Mallareddy',
  'Uttar Pradesh - B.Tech - Noida International University',
  'Bhopal - B.Tech - Scope Global Skill University',
  'Nashik - B.Tech - Sandip University',
  'Thenpattinam - B.Tech - AMET',
  'Tamil Nadu - B.Tech - Crescent',
  'Gurgaon - B.Tech - Sushant University',
  'Mathura - B.Tech - Sanskriti University',
  'Guntur - B.Tech - Chalapathi Madhabaka'
].map((option) => ({ label: option, value: option }));

export const TAKE_ADMISSION_ACCOMMODATION_OPTIONS = [
  'Day Scholar',
  'Hosteler'
].map((option) => ({
  label: option,
  value: option
}));
